import ITexts from "./ITexts";

const de: ITexts = {
  project_documents_alert_message: "Die restlichen Dokumente werden nur angemeldeten Benutzern angezeigt."
};

export default de;
